import storage from "./storage";
export const protoMeta = () => {
  return {
    authorization: storage.token,
    language: 'zh-CN',
    'client-id': storage.clientID,
    'device-type': 'web',
  }
};
